import { css } from '@emotion/core';

const cursorPointer = css`
  cursor: pointer;
`;

export const style = { cursorPointer };
